import * as yup from 'yup'

export const LoginSchema = yup.object().shape({
  identifier: yup.string().required('RequiredInput'),
  password: yup.string().min(5, 'min5Chars').required('RequiredInput'),
})
